import React from 'react';
import classNames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import styles from 'assets/jss/material-dashboard-pro-react/components/cardIconStyle';

const useStyles = makeStyles(styles);

export type ICardIconColor = 'warning' | 'success' | 'danger' | 'info' | 'primary' | 'rose' | 'white';
type ICardIconSize = 'xs' | 'sm' | 'lg';

interface ICardIconProps {
	className?: string;
	color?: ICardIconColor;
	uiColor?: string;
	children: React.ReactElement;
	size: ICardIconSize;
}

// TODO: remove @ts-ignore

function CardIcon({ className, children, color = 'primary', size = 'lg', uiColor, ...rest }: ICardIconProps) {
	const classes = useStyles();
	const cardIconClasses = classNames({
		[classes.cardIcon]: true,
		// @ts-ignore
		[classes[color + 'CardHeader']]: color,
		[`${className}`]: className !== undefined,
		// @ts-ignore
		[classes[`${size}Icon`]]: true,
	});
	return (
		<div className={cardIconClasses} style={{ backgroundColor: uiColor }} {...rest}>
			{children}
		</div>
	);
}

export default CardIcon;
